exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media(pointer: fine),(pointer: none){.card-description__description{display:none}.card-description__show-more{font-size:12px;line-height:16px;font-weight:inherit}}@media(pointer: coarse){.card-description__description{display:inherit}.card-description__show-more{display:none}}.card-description__description{font-size:16px;line-height:24px;font-weight:inherit;color:#727e82;height:100%;width:100%;min-height:110px;margin-bottom:8px;overflow:hidden}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};